import { ActionTree } from "vuex";
import { State } from "./state";
import { findAll, filter } from "@/store/Crud/functions/actions";

export default <ActionTree<State, any>>{
  findAll,
  filter,
};
